/**
 * #978 — note text rules (contract §1): plain text, line breaks preserved,
 * at most 4,000 Unicode code points, and an empty trimmed note means CLEAR.
 */

export const NOTE_MAX_CODE_POINTS = 4000;

/** Code points, not UTF-16 units: an emoji counts once, as the contract says. */
export function codePointLength(text: string): number {
  let n = 0;
  for (const _ of text) n += 1;
  return n;
}

/**
 * What a Save sends: `null` clears the note. Only the ENDS are trimmed for the
 * emptiness test and storage; interior line breaks and spacing are the
 * trader's formatting and are kept.
 */
export function noteForSave(draft: string): string | null {
  const trimmed = draft.trim();
  return trimmed === '' ? null : trimmed;
}

export function isOverLimit(draft: string): boolean {
  return codePointLength(draft.trim()) > NOTE_MAX_CODE_POINTS;
}
